function panelId(tab) {
    return tab.getAttribute("aria-controls") ?? "";
}
export const ProductDocuments = (element) => {
    const tabs = Array.from(element.querySelectorAll("[data-document-tab]"));
    const panels = Array.from(element.querySelectorAll("[data-document-panel]"));
    if (tabs.length < 2 || panels.length < 2) {
        return;
    }
    const select = (id) => {
        tabs.forEach((tab) => {
            const selected = panelId(tab) === id;
            tab.setAttribute("aria-selected", selected ? "true" : "false");
            tab.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
            panel.hidden = panel.id !== id;
        });
    };
    const onClick = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }
        const tab = target.closest("[data-document-tab]");
        if (!tab || !element.contains(tab)) {
            return;
        }
        const id = panelId(tab);
        if (!id) {
            return;
        }
        event.preventDefault();
        select(id);
    };
    const onKeyDown = (event) => {
        const target = event.target;
        if (!(target instanceof HTMLButtonElement) || !target.matches("[data-document-tab]")) {
            return;
        }
        const current = tabs.indexOf(target);
        if (current < 0) {
            return;
        }
        let next = current;
        if (event.key === "ArrowRight") {
            next = (current + 1) % tabs.length;
        }
        else if (event.key === "ArrowLeft") {
            next = (current - 1 + tabs.length) % tabs.length;
        }
        else if (event.key === "Home") {
            next = 0;
        }
        else if (event.key === "End") {
            next = tabs.length - 1;
        }
        else {
            return;
        }
        event.preventDefault();
        const id = panelId(tabs[next]);
        if (!id) {
            return;
        }
        select(id);
        tabs[next].focus();
    };
    element.addEventListener("click", onClick);
    element.addEventListener("keydown", onKeyDown);
    const initial = panelId(tabs.find((tab) => tab.getAttribute("aria-selected") === "true") ?? tabs[0]) || panels[0].id;
    select(initial);
    return () => {
        element.removeEventListener("click", onClick);
        element.removeEventListener("keydown", onKeyDown);
    };
};
